/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function ($) {
  // Remove empty P tags created by WP inside of Accordion and Orbit
  $(".accordion p:empty, .orbit p:empty").remove();

  // Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
    if ($(this).innerWidth() / $(this).innerHeight() > 1.5) {
      $(this).wrap("<div class='widescreen responsive-embed'/>");
    } else {
      $(this).wrap("<div class='responsive-embed'/>");
    }
  });

  // Prevent Dropdown buttons in Main Nav from doing anything when clicked
  $(".menu-item a[href='#']").on("click", function (event) {
    event.preventDefault();
  });

  $("#AvgBill, #UtilityRate, #Years").on("change", function () {
    var electricityBill = parseFloat($("#AvgBill").val());
    var utilityRate = parseFloat($("#UtilityRate").val());
    var numberOfYears = parseInt($("#Years").val());

    if (
      !isNaN(electricityBill) &&
      !isNaN(utilityRate) &&
      !isNaN(numberOfYears)
    ) {
      let total = 0;
      for (let year = 0; year < numberOfYears; year++) {
        total += electricityBill * 12 * Math.pow(1 + utilityRate, year);
      }

      // Round up to nearest whole number
      total = Math.ceil(total);

      // Format with commas
      let formattedTotal = total
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      $("#FinalAmount").val(`$${formattedTotal}`);
    }
  });

  function isMobile() {
    return $(window).width() <= 640;
  }

  function updateLayout() {
    if (isMobile()) {
      $(".contact-forms-content-container").hide(); // Hide shared container
      $(".contact-forms-content").hide(); // Hide all content
      $(".contact-forms-tab").removeClass("active"); // Remove active class from tabs

      $(".contact-forms-content").each(function () {
        let targetTab = $(".contact-forms-tab[data-target='" + this.id + "']");
        $(this).insertAfter(targetTab).hide(); // Move content below tab
      });
    } else {
      $(".contact-forms-content-container").show();
      $(".contact-forms-container").append(
        $(".contact-forms-content-container")
      ); // Restore shared container
      $(".contact-forms-content").hide();

      // Ensure the active tab on desktop shows the correct content
      let activeTab = $(".contact-forms-tab.active").first();
      if (activeTab.length) {
        $("#" + activeTab.data("target")).show();
      } else {
        // If no tab is active, make the first one active
        $(".contact-forms-tab").first().addClass("active");
        $(".contact-forms-content").first().show();
      }
    }
  }

  // Tab Click Functionality
  $(".contact-forms-tab").click(function () {
    let target = $(this).data("target");
    let $content = $("#" + target);

    if (isMobile()) {
      // Mobile: Toggle content below each tab
      let isCurrentlyActive = $(this).hasClass("active");

      $(".contact-forms-tab").removeClass("active");
      $(".contact-forms-content").slideUp();

      if (!isCurrentlyActive) {
        $(this).addClass("active");
        $content.slideDown("slow");
      }
    } else {
      // Desktop: Normal tab behavior
      $(".contact-forms-tab").removeClass("active");
      $(".contact-forms-content").hide();

      $(this).addClass("active");
      $content.show();
    }
  });

  // Activate refer-a-friend tab/content if anchor is present
  if (window.location.hash === "#refer-a-friend") {
    // Remove all active classes
    $(".contact-forms-tab").removeClass("active");
    $(".contact-forms-content").hide();

    // Find the refer-a-friend tab and content
    var $tab = $(".contact-forms-tab[data-target='refer-a-friend']");
    var $content = $("#refer-a-friend");

    // Add active class and show content
    $tab.addClass("active");
    // if (isMobile()) {
    //   $content.slideDown(0); // Show instantly on load
    // } else {
    //   $content.show();
    // }
  }

  $(window).resize(updateLayout);
  updateLayout(); // Run on page load

  // Element: "Read More" Toggle Buttons
  var instance = ["1", "2", "3", "4", "5"];
  $.each(instance, function (i, val) {
    $(".toggle-" + val).click(function (e) {
      e.preventDefault();
      $(".showHide-" + val).slideToggle();
      $(this).text($(this).text() == "Read More" ? "Read Less" : "Read More");
    });
  });

  // Element: "Read More" Toggle Buttons
  if ($(window).width() < 640) {
    var mobileInstance = ["1", "2", "3", "4", "5"];
    $.each(mobileInstance, function (i, val) {
      $(".mobile-toggle-" + val).click(function (e) {
        e.preventDefault();
        $(".showHideMobile-" + val).slideToggle();
        $(this).toggleClass("after-rotate");
      });
    });
  }
});
